export enum VIDEO_SHARE_SETTINGS {
	PRIVATE = 'private',
	PUBLIC = 'public',
	BOTH = 'both'
}
